import Button from '@betterfunnel/ui-core/Button';
import MenuButton from '@betterfunnel/ui-core/MenuButton';
import { PlusIcon } from '@heroicons/react/24/solid';
import * as Sentry from '@sentry/react';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import facebookAdsIcon from '../assets/images/facebookAdsIcon.png';
import googleAdsIcon from '../assets/images/googleAdsIcon.png';
import { UserContext } from '../contexts/UserContext';
import ConnectAdsAccountsModal from '../modals/ConnectAdsAccountsModal';
import { track } from '../utils/analytics';
import {
    DEFAULT_FACEBOOK_ADS_SCOPES,
    DEFAULT_GOOGLE_ADS_SCOPES,
    getFacebookUrl,
    getGoogleUrl,
} from '../utils/auth';

export const ConnectAdsAccountButton = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { createOAuthRequest } = useContext(UserContext);

  const [connectAccountsModalOpen, setConnectAccountsModalOpen] = useState<{
    requestId: string;
    provider: 'google' | 'facebook';
  }>();

  useEffect(() => {
    const googleAdsRequestId = searchParams.get('googleAdsRequestId');
    const facebookAdsRequestId = searchParams.get('facebookAdsRequestId');
    if (googleAdsRequestId) {
      setConnectAccountsModalOpen({
        requestId: googleAdsRequestId,
        provider: 'google',
      });
    } else if (facebookAdsRequestId) {
      setConnectAccountsModalOpen({
        requestId: facebookAdsRequestId,
        provider: 'facebook',
      });
    }
  }, [searchParams]);

  return (
    <>
      <ConnectAdsAccountsModal
        provider={connectAccountsModalOpen?.provider || 'google'}
        requestId={connectAccountsModalOpen?.requestId || ''}
        open={!!connectAccountsModalOpen}
        onClose={() => {
          setSearchParams(new URLSearchParams());
          setConnectAccountsModalOpen(undefined);
        }}
      />
      <MenuButton
        customButton={
          <Button icon={<PlusIcon className="h-4 w-4 text-white" />}>
            Connect
          </Button>
        }
        items={[
          {
            icon: <img src={googleAdsIcon} />,
            title: 'Connect a Google Ads Account',
            onClick: async () => {
              track('connect_google_ads_button_click');

              try {
                const from = location.pathname;
                const state = await createOAuthRequest(
                  'google',
                  from,
                  DEFAULT_GOOGLE_ADS_SCOPES,
                );

                window.location.replace(
                  getGoogleUrl(from, state, DEFAULT_GOOGLE_ADS_SCOPES),
                );
              } catch (e) {
                Sentry.captureException(e);
                console.error(e);
              }
            },
          },
          {
            icon: <img src={facebookAdsIcon} />,
            title: 'Connect a Meta Ads Account',
            onClick: async () => {
              track('connect_meta_ads_button_click');

              try {
                const from = location.pathname;
                const state = await createOAuthRequest(
                  'facebook',
                  from,
                  DEFAULT_FACEBOOK_ADS_SCOPES,
                );

                window.location.replace(
                  getFacebookUrl(from, state, DEFAULT_FACEBOOK_ADS_SCOPES),
                );
              } catch (e) {
                Sentry.captureException(e);
                console.error(e);
              }
            },
          },
        ]}
      />
    </>
  );
};
